import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { FiSearch } from "react-icons/fi";
import NavSearch from "../NavSearch";

type ScrollToTopButtonProps = {
  show?: boolean;
};

const ScrollToTopButton = styled.button<ScrollToTopButtonProps>`
  position: fixed;
  bottom: -50px;
  right: 20px;
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 99;
  opacity: 0;
  transition: opacity 0.6s ease, bottom 0.6s ease;
  ${({ show }) =>
    show &&
    css`
      opacity: 1;
      bottom: 20px;
    `}
`;
const OpenSearchButton = styled(ScrollToTopButton)`
  bottom: 80px;

  ${({ show }) =>
    show &&
    css`
      opacity: 1;
      bottom: 70px;
    `}
`;

const HelperButtons = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
  const openSearchModal = () => {
    setIsSearchModalOpen(true);
  };

  // Function to close search modal
  const closeSearchModal = () => {
    setIsSearchModalOpen(false);
  };
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);
  const toggleVisibility = () => {
    if (window.scrollY > 100) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  return (
    <>
      <ScrollToTopButton onClick={scrollToTop} show={showScrollButton}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          className="h-5 w-5"
        >
          <path
            fillRule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </svg>
      </ScrollToTopButton>
      <OpenSearchButton onClick={openSearchModal} show={showScrollButton}>
        <FiSearch size={20} />
      </OpenSearchButton>
      {isSearchModalOpen && <NavSearch onClose={closeSearchModal} />}
    </>
  );
};

export default HelperButtons;
